// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3X_N3","errorLogs":"EditorFooter_errorLogs__2RyBp"};